/**
 * 分类题
 */
import QuestionClassify from './view';
import './index.less';

export default QuestionClassify;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/classify/index.js